import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Accordion, Col, Container, Form, Row } from "react-bootstrap";


import questionsData from "@/lib/industryQuestions.json";
export default function IndustryQuestionsView()
{
    const router = useRouter();
    const { from } = router.query;
    const [data, setData] = useState({});
    const [matchedKey, setMatchedKey] = useState(null);

    useEffect(() =>
    {
        if (!from) return;
        setData(questionsData);

        const match = Object.keys(questionsData).find(
            (key) => key.trim().toLowerCase() === from.trim().toLowerCase()
        );
        if (match)
        {
            setMatchedKey(match);
        } else
        {
            console.warn("No match found for:", from);
        }
    }, [from]);

    // const groupedData = data[matchedKey]?.reduce((acc, item) =>
    // {
    //     if (!acc[item.subheading])
    //     {
    //         acc[item.subheading] = [];
    //     }
    //     acc[item.subheading].push(item);
    //     return acc;
    // }, {});
    return (
        <>
            <Container className="py-5">
                <div className="text-start mb-4">
                    <Link
                        variant="secondary"
                        href={"/industry"}
                        className=" text-light btn demo-btn"
                    >
                        Back
                    </Link>
                </div>
                <h2
                    className="fw-bold text-center mb-3 secondaryColor"
                >
                    {matchedKey}
                </h2>
                <p className="text-center mb-4">Please register your company to access the full library of Question templates.
                    <Link
                        variant="secondary"
                        href={"/register"}
                        className=" text-light btn bg-secondary-owner ms-3"
                    >
                        Register
                    </Link>
                </p>
                <Row className="justify-content-center">
                    <Col md={8} lg={8}>
                        <div>
                            {/* {matchedKey === "Mental Health Industry" ||
                                matchedKey === "Mental Health FIFO" ? (
                                <>
                                    {data[matchedKey]?.length > 0 && (
                                        <div className="mb-4">
                                            {data[matchedKey][0]?.author && (
                                                <h6 className="fw-bold mb-2">
                                                    {data[matchedKey][0].author}
                                                </h6>
                                            )}

                                            {data[matchedKey][0]?.instructions && (
                                                <p className="text-muted">
                                                    {data[matchedKey][0].instructions}
                                                </p>
                                            )}
                                        </div>
                                    )}

                                    <Accordion defaultActiveKey="0">

                                        {groupedData &&
                                            Object.entries(groupedData).map(
                                                ([subheading, questions], groupIndex) => (
                                                    <Accordion.Item
                                                        eventKey={groupIndex?.toString()}
                                                        key={groupIndex}
                                                        
                                                    >
                                                        <Accordion.Header>
                                                            {subheading}
                                                        </Accordion.Header>
                                                        <Accordion.Body>
                                                            {questions.map((item, index) => (
                                                                <div key={index} className="mb-4">
                                                                    <p className="fw-medium">
                                                                        {item.question}
                                                                    </p>
                                                                    {item.desc && (
                                                                        <p className="small text-muted">
                                                                            {item.desc}
                                                                        </p>
                                                                    )}
                                                                    <Form.Select size="lg" className="w-50">
                                                                        <option value="">Select an option</option>
                                                                        {item.options?.map((opt, optIdx) => (
                                                                            <option key={optIdx} value={opt}>
                                                                                {opt}
                                                                            </option>
                                                                        ))}
                                                                    </Form.Select>

                                                                </div>
                                                            ))}

                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                )
                                            )}
                                    </Accordion>
                                </>
                            )  */}


                            <>
                                {matchedKey ? (
                                    <div className="mb-4  pb-3">
                                        {data[matchedKey]?.slice(0, 4).map((item, idx) => (
                                            <div key={idx} className="mb-4">
                                                <h6 className="fw-bold mb-3">{item.question}</h6>
                                                <Form className="ms-2">
                                                    {item.options?.map((opt, optIdx) => (
                                                        <div key={optIdx} className="d-flex align-items-center mb-2">
                                                            <Form.Check.Input type="checkbox" disabled className="custom-blue-checkbox"
                                                            />
                                                            <span className="ms-2">{opt}</span>
                                                        </div>
                                                    ))}
                                                </Form>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <p className="text-danger text-center">Select an industry to view questions.</p>
                                )}
                            </>

                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
IndustryQuestionsView.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;